var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconGallerySelectionW9C5V6Ud4J(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0072ff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gallery Selection") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.66,15.93A2.08,2.08,0,0,0,48,18V39.87A8.13,8.13,0,0,1,39.87,48H18a2,2,0,1,0,0,4H41.21A10.79,10.79,0,0,0,52,41.21V17.9A2,2,0,0,0,49.66,15.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.71,56H30a2,2,0,1,0,0,4H44.56A15.43,15.43,0,0,0,60,44.56V42a2,2,0,0,0-2.34-2A2.08,2.08,0,0,0,56,42.11v1.6A12.29,12.29,0,0,1,43.71,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,12.24V35.76A8.24,8.24,0,0,0,12.24,44H35.76A8.24,8.24,0,0,0,44,35.76V12.24A8.24,8.24,0,0,0,35.76,4H12.24A8.24,8.24,0,0,0,4,12.24Zm21.63,5.39,4,4a2.11,2.11,0,0,1,0,3l-1.09,1.09a2,2,0,0,0,0,2.84h0a2,2,0,0,0,2.85,0L34,26l1.31-1.29a2.75,2.75,0,0,1,4.68,2v7.65A5.69,5.69,0,0,1,34.31,40H13.66A5.66,5.66,0,0,1,8,33.75,5.93,5.93,0,0,1,9.8,30.2L22.37,17.63A2.31,2.31,0,0,1,25.63,17.63ZM18,14a4,4,0,1,1-4-4A4,4,0,0,1,18,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,24a2,2,0,0,0-2,2v8a2,2,0,0,0,4,0V26A2,2,0,0,0,58,24Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconGallerySelectionW9C5V6Ud4J);
export default __webpack_public_path__ + "static/media/reshot-icon-gallery-selection-W9C5V6UD4J.296ffadb4cf9c2361b9d62ab4d86e44a.svg";
export { ForwardRef as ReactComponent };